(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["viltura-cart-timer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.VilturaCartTimer) {
      window.VilturaCartTimer.sync();
      return;
    }

    const duration = 15 * 60 * 1000;
    const storageKey = 'viltura-cart-expires-at';
    const root = window.Shopify?.routes?.root || '/';
    const template = document.getElementById('VilturaCartTimerTemplate');
    let expiresAt = Number(localStorage.getItem(storageKey)) || 0;
    let cartSignature = null;
    let intervalId = null;
    let refreshTimeout = null;
    let clearing = false;

    const timerNodes = () => document.querySelectorAll('[data-viltura-cart-timer]');

    const formatTime = (milliseconds) => {
      const seconds = Math.max(0, Math.ceil(milliseconds / 1000));
      const minutes = Math.floor(seconds / 60);
      return `${String(minutes).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    };

    const setNodeText = (node, value) => {
      if (node.firstChild) node.firstChild.nodeValue = value;
    };

    const renderTime = () => {
      if (!expiresAt || cartSignature === '') return;
      const remaining = expiresAt - Date.now();

      if (remaining <= 0) {
        expireCart();
        return;
      }

      const time = formatTime(remaining);
      timerNodes().forEach((container) => {
        const countdown = container.querySelector('[data-viltura-cart-countdown]');
        if (countdown) setNodeText(countdown, time);
      });
    };

    const mount = () => {
      if (!template) return;

      const targets = document.querySelectorAll('.cart-drawer__summary, .cart-page__summary');
      targets.forEach((target) => {
        if (target.querySelector('[data-viltura-cart-timer]')) return;
        target.prepend(template.content.cloneNode(true));
      });
      renderTime();
    };

    const unmount = () => {
      timerNodes().forEach((node) => node.remove());
    };

    const startClock = () => {
      if (intervalId) return;
      intervalId = window.setInterval(renderTime, 1000);
    };

    const stopClock = () => {
      if (!intervalId) return;
      window.clearInterval(intervalId);
      intervalId = null;
    };

    // Shopify changes line keys when discounts change. Track merchandise instead
    // so applying or removing a coupon does not restart the countdown.
    const signatureFor = (cart) => cart.items.map((item) => JSON.stringify([
      item.variant_id || item.id,
      item.quantity,
      Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)),
      item.selling_plan_allocation?.selling_plan?.id || null,
    ])).sort().join('|');

    const expireCart = async () => {
      if (clearing || cartSignature === '') return;
      clearing = true;
      stopClock();
      timerNodes().forEach((container) => {
        const countdown = container.querySelector('[data-viltura-cart-countdown]');
        const announcement = container.querySelector('[data-viltura-cart-announcement]');
        const message = container.dataset.expiredMessage || '';
        if (countdown) setNodeText(countdown, '00:00');
        if (announcement) setNodeText(announcement, message);
      });

      try {
        const response = await fetch(`${root}cart/clear.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({}),
        });
        if (!response.ok) throw new Error('Cart expiration failed');
        localStorage.removeItem(storageKey);
        window.location.reload();
      } catch {
        clearing = false;
        expiresAt = Date.now() + 60 * 1000;
        localStorage.setItem(storageKey, String(expiresAt));
        startClock();
      }
    };

    const sync = async () => {
      try {
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        const nextSignature = signatureFor(cart);
        const changed = cartSignature !== null && cartSignature !== nextSignature;
        cartSignature = nextSignature;

        if (cart.item_count === 0) {
          expiresAt = 0;
          localStorage.removeItem(storageKey);
          stopClock();
          unmount();
          return;
        }

        if (expiresAt && expiresAt <= Date.now()) {
          mount();
          expireCart();
          return;
        }

        if (!expiresAt || changed) {
          expiresAt = Date.now() + duration;
          localStorage.setItem(storageKey, String(expiresAt));
        }

        mount();
        startClock();
        renderTime();
      } catch {
        return;
      }
    };

    const scheduleSync = () => {
      window.clearTimeout(refreshTimeout);
      refreshTimeout = window.setTimeout(sync, 250);
    };

    const observer = new MutationObserver((mutations) => {
      const hasStructuralChange = mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length);
      if (hasStructuralChange) scheduleSync();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pageshow', sync);
    window.addEventListener('focus', sync);
    window.addEventListener('storage', (event) => {
      if (event.key !== storageKey) return;
      expiresAt = Number(event.newValue) || 0;
      renderTime();
    });

    window.VilturaCartTimer = { sync };
    sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
